import firebase from "../../firebase";

export default function({ officeId, lateArrivals }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingAdmin",
        funcName: "updateVisitLate",
        data: {
            officeId,
            lateArrivals,
        }
    });
}
